import { useEffect, useState } from "react";
import { ProSidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import { Box, Popover, Button } from "@mui/material";
import { Link } from "react-router-dom";
import "react-pro-sidebar/dist/css/styles.css";
import { colors } from "../../theme";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import ReportIcon from "@mui/icons-material/Report";
import CampaignIcon from "@mui/icons-material/Campaign";
import GraphicEqIcon from "@mui/icons-material/GraphicEq";
import LanguageIcon from "@mui/icons-material/Language";
import API from "../../api/index";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import MovingIcon from "@mui/icons-material/Moving";
import LanIcon from "@mui/icons-material/Lan";
import PermDataSettingIcon from "@mui/icons-material/PermDataSetting";
import WebStoriesIcon from "@mui/icons-material/WebStories";
import AnalyticsIcon from "@mui/icons-material/Analytics";
import MapIcon from "@mui/icons-material/Map";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import Grid from "@mui/material/Grid";
import PublicIcon from '@mui/icons-material/Public';

const Item = ({ title, to, icon, selected, setSelected }) => {
  return (
    <MenuItem
      active={selected === title}
      style={{
        color: colors.grey[100],
      }}
      onClick={() => {
        window.sessionStorage.setItem("selectedTab", title);
        setSelected(title);
      }}
      icon={icon}
    >
      <Link to={to} />
    </MenuItem>
  );
};

const Sidebar = () => {
  const [anchorEl, setAnchorEl] = useState(null);

  const [selected, setSelected] = useState(() => {
    const saved = window.sessionStorage.getItem("selectedTab");
    return saved !== null ? saved : "Dashboard";
  });

  const [, setImage] = useState();
  const [, setCompanyName] = useState();
  const [, setImageType] = useState();
  const [, setNome] = useState();
  const [, setCognome] = useState();
  const [submenuOpen, setSubmenuOpen] = useState({
    security: false,
    tiresia: false,
    network: false,
    intelligence: false,
  });
  const [openPopovers, setOpenPopovers] = useState({
    security: false,
    tiresia: false,
    network: false,
    intelligence: false,
  });

  const toggleSubmenu = (submenu, event) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
    setSubmenuOpen((prevState) => ({
      ...prevState,
      [submenu]: !prevState[submenu],
    }));
    setOpenPopovers((prevOpenPopovers) => ({
      ...prevOpenPopovers,
      [submenu]: !prevOpenPopovers[submenu],
    }));
  };

  const determineParentSubmenu = (item) => {
    if (SecurityLog.includes(item)) {
      return "security";
    } else if (TiresiaEngine.includes(item)) {
      return "tiresia";
    } else if (MyNetwork.includes(item)) {
      return "network";
    } else if (MyNetwork.includes(item)) {
      return "intelligence";
    }
    return null;
  };

  useEffect(() => {
    const parentSubmenu = determineParentSubmenu(selected);
    setSubmenuOpen((prevState) => ({
      ...prevState,
      [parentSubmenu]: true,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- determineParentSubmenu is a plain function redefined every render; adding it (and selected, which it closes over) would run this mount-only effect on every render instead of once
  }, []);

  const SecurityLog = ["Critical", "Highlights", "Alert", "Movements", "High"];
  const MyNetwork = [
    "Overview",
    "Inventory",
    "Infrastructure Log",
  ];
  const TiresiaEngine = ["Network Entropy", "Tiresia-IA Entropy"];

  useEffect(() => {
    const fetchData = () => {
      API.getDataUsers()
        .then((result) => {
          setImage(result.data.profileImage);
          setCompanyName(result.data.ragioneSociale);
          setImageType(result.data.imageType);
          setNome(result.data.nome);
          setCognome(result.data.cognome);
        })
        .catch((error) => {
          console.error('[fetchData] failed to fetch user data:', error);
        });
    };

    fetchData();
  });

  // Salva lo stato nel localStorage ogni volta che cambia
  useEffect(() => {
    localStorage.setItem("selectedTab", selected);
  }, [selected]);

  return (
    <Box
      className="bottom-0 flex justify-between z-10"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      sx={{
        position: "fixed",
        left: 0,
        zIndex: 1000,
        height: "50px",
        width: "100%",
        // //overflowY: "hidden",
        "& .pro-sidebar" : {
          boxShadow: "0px 0px 10px #eaeaea" // Corretto l'ombra
        },
        "& .pro-sidebar-inner": {
          backgroundColor: "#1e1e1e !important",
         //borderTop: "solid 1px #eaeaea",
        },
        "& .pro-icon-wrapper": {
          backgroundColor: "transparent !important",
        },
        "& .pro-inner-item": {
          padding: "5px 10px 5px 10px !important",
        },
        "& .pro-inner-item:hover": {
          color: "#73ccd7 !important",
        },
        "& .pro-menu-item.active": {
          color: "#52a0a6 !important",
        },
        // "& .pro-sidebar-layout": {
        //   overflow: "hidden !important",
        // }
      }}
    >
      <ProSidebar  width={"100%"}>
        <Menu iconShape="square">
          {/* LOGO AND MENU ICON */}

          <Grid container className="sidebarMobile" spacing={1}>
            <SubMenu
              icon={
                <BarChartOutlinedIcon sx={{ width: "30px", height: "auto" }} />
              }
              open={submenuOpen.security}
              onClick={(e) => toggleSubmenu("security", e)}
              popperarrow={false}
            >
              <Popover
                className="popoverNavBar"
                id="security"
                open={openPopovers.security}
                anchorEl={anchorEl}
                sx={{ marginLeft: "-15px" }}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    background: `#1a1a1a !important;`,
                  }}
                >
                  <Button
                    onClick={() => {
                      window.location.href = "/user/security/critical";
                    }}
                  >
                    <Item
                      title="Critical"
                      to="/user/security/critical"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<ReportIcon />}
                    />
                  </Button>
                  <Button
                    onClick={() => {
                      window.location.href = "/user/tiresia-engine/highlights";
                    }}
                  >
                    <Item
                      title="Highlights"
                      to="/user/tiresia-engine/highlights"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<MovingIcon />}
                    />
                  </Button>
                  <Button
                    onClick={() => {
                      window.location.href = "/user/security/high";
                    }}
                  >
                    <Item
                      title="High"
                      to="/user/security/high"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<HighlightOffIcon />}
                    />
                  </Button>
                  <Button
                    onClick={() => {
                      window.location.href = "/user/security/alert";
                    }}
                  >
                    <Item
                      title="Alert"
                      to="/user/security/alert"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<CampaignIcon />}
                    />
                  </Button>
                  <Button
                    onClick={() => {
                      window.location.href = "/user/security/movements";
                    }}
                  >
                    <Item
                      title="Movements"
                      to="/user/security/movements"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<GraphicEqIcon />}
                    />
                  </Button>
                  {/*<Button
                  onClick={() => {
                    window.location.href = "/user/security/internal-detection";
                  }}
                >
                  <Item
                    title="Internal Detection"
                    to="/user/security/internal-detection"
                    selected={selected}
                    setSelected={setSelected}
                    icon={<RadarIcon />}
                  />
                </Button>*/}
                </Box>
              </Popover>
            </SubMenu>
            <SubMenu
              icon={
                <PublicIcon
                  sx={{ width: "30px", height: "auto" }}
                />
              }
              popperarrow={false}
              open={submenuOpen.intelligence}
              onClick={(e) => toggleSubmenu("intelligence", e)}
            >
              <Popover
                className="popoverNavBar"
                id="2"
                anchorEl={anchorEl}
                open={openPopovers.intelligence}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    background: `#1a1a1a !important`,
                  }}
                >
                  <Button
                    onClick={() => {
                      window.location.href = "/user/extra/map";
                    }}
                  >
                    <Item
                      title="Map"
                      to="/user/extra/map"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<MapIcon sx={{ width: "30px", height: "auto" }} />}
                    />
                  </Button>
                  <Button
                    onClick={() => {
                      window.location.href =
                        "/user/security/threat-intelligence";
                    }}
                  >
                    <Item
                      title="Threat Intelligence"
                      to="/user/security/threat-intelligence"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<LanguageIcon />}
                    />
                  </Button>
                </Box>
              </Popover>
            </SubMenu>
            <Item
              title="Dashboard"
              to="/user/home/"
              icon={<HomeOutlinedIcon sx={{ width: "35px", height: "auto" }} />}
              selected={selected}
              setSelected={setSelected}
            />

            <SubMenu
              icon={<LanIcon sx={{ width: "30px", height: "auto" }} />}
              open={submenuOpen.network}
              onClick={(e) => toggleSubmenu("network", e)}
              popperarrow={false} // Assumendo che questa prop controlli la freccia
            >
              <Popover
                className="popoverNavBar"
                open={openPopovers.network}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    background: `#1a1a1a !important`,
                  }}
                >
                  <Button
                    onClick={() => {
                      window.location.href = "/user/network-status/overview";
                    }}
                  >
                    <Item
                      title="Overview"
                      to="/user/network-status/overview"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<AnalyticsIcon />}
                    />
                  </Button>
                  <Button
                    onClick={() => {
                      window.location.href = "/user/network-status/status";
                    }}
                  >
                    <Item
                      title="Inventory"
                      to="/user/network-status/status"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<PermDataSettingIcon />}
                    />
                  </Button>
                  <Button
                    onClick={() => {
                      window.location.href =
                        "/user/network-status/infrastructure-log";
                    }}
                  >
                    <Item
                      title="Infrastructure Log"
                      to="/user/network-status/infrastructure-log"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<WebStoriesIcon />}
                    />
                  </Button>
                </Box>
              </Popover>
            </SubMenu>
            <SubMenu
              icon={
                <PrecisionManufacturingIcon
                  sx={{ width: "30px", height: "auto" }}
                />
              }
              popperarrow={false}
              open={submenuOpen.tiresia}
              onClick={(e) => toggleSubmenu("tiresia", e)}
            >
              <Popover
                className="popoverNavBar"
                id="4"
                anchorEl={anchorEl}
                open={openPopovers.tiresia}
                anchorOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
              >{/*
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    background: `#1a1a1a !important`,
                  }}
                >
                  
                  <Button
                    onClick={() => {
                      window.location.href =
                        "/user/tiresia-engine/network-entropy";
                    }}
                  >
                    <Item
                      title="Network Entropy"
                      to="/user/tiresia-engine/network-entropy"
                      selected={selected}
                      setSelected={setSelected}
                      icon={<HubIcon />}
                    />
                  </Button>
                </Box>*/}
              </Popover>
            </SubMenu>
            {/* <Item
              title="Ticket"
              to="/user/support/ticket"
              selected={selected}
              setSelected={setSelected}
              icon={<LocalActivityIcon sx={{width: "30px", height: "auto"}}/>}
            /> */}
          </Grid>
        </Menu>
      </ProSidebar>
    </Box>
  );
};

export default Sidebar;
